import api from "./axios";
import { API_ENDPOINTS } from "../constants";
import { logError } from "../common/utils/logger";
import { encryptJourneyQueryValue } from "../common/utils/journeyEncryption";


const RESUME_DOB_SESSION_KEY = "rnlic_resumeDob";
const getResumeDobStorageKey = (applicationNumber) =>
  `${RESUME_DOB_SESSION_KEY}:${String(applicationNumber || "").trim()}`;

const readStoredResumeDob = (applicationNumber) => {
  try {
    const dob =
      (applicationNumber
        ? sessionStorage.getItem(getResumeDobStorageKey(applicationNumber))
        : null) ||
      sessionStorage.getItem(RESUME_DOB_SESSION_KEY);
    return typeof dob === "string" && dob.trim() ? dob.trim() : null;
  } catch {
    return null;
  }
};

const readDobFromLeadFormSession = () => {
  try {
    const rawLeadForm = sessionStorage.getItem("inlic_lead_form_data");
    if (!rawLeadForm) return null;
    const parsedLeadForm = JSON.parse(rawLeadForm);
    const dob = parsedLeadForm?.dateOfBirth;
    return typeof dob === "string" && dob.trim() ? dob.trim() : null;
  } catch {
    return null;
  }
};

const resolveOwnershipDob = (applicationNumber) =>
  readStoredResumeDob(applicationNumber) || readDobFromLeadFormSession();

/**
 * Fetch policy status before OTP verification
 */
export const getPolicyStatus = async (applicationNumber) => {
  try {
    if (!applicationNumber) {
      throw new Error("applicationNumber is required");
    }

    // FRONTEND-ONLY MOCK (temporary): bypass getPolicyStatus API for BizOps testing.
    // Enable only on UAT-like URLs to avoid affecting non-UAT environments.
    const isUat =
      typeof window !== "undefined" &&
      String(window.location?.href || "").toLowerCase().includes("uat");

    if (isUat && String(applicationNumber).trim() === "N0000296") {
      return {
        environment: "uat",
        response: {
          Application_Number: "N0000296",
          Policy_Status: "",
          Message: "SUCCESS",
          PIVC_Status: "Completed",
        },
        success: true,
      };
    }

    const dateOfBirth = resolveOwnershipDob(applicationNumber);
    const response = await api.get(API_ENDPOINTS.GET_POLICY_STATUS, {
      params: {
        applicationNumber: encryptJourneyQueryValue(applicationNumber),
        ...(dateOfBirth ? { dateOfBirth: encryptJourneyQueryValue(dateOfBirth) } : {})
      }
    });

    return response?.data ?? null;

  } catch (error) {
    logError("[getPolicyStatus] Failed", error);
    throw error;
  }
};